<template>
  <div>
    <coders-list v-if="project" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CodersList from '@/components/coding-admin/coders-list';
export default {
  name: 'ProjectCodersList',
  components: { 'coders-list': CodersList },
  data: function() {
    return {
    }
  },

  mounted() {
    const projectUid = this.$route.params.project_uid;
    this.$emit('setHeaderPrimaryName', this.project.project_name);
    // this.$emit('setHeaderSecondaryName', 'Coders');
  },

  computed: {
       ...mapState({
        user: state => state.user.user.data,
        project: state => state.projects.project.data
      }),
  },
};
</script>